import src from "IMAGE";
export default { src, width: 402, height: 155, blurWidth: 0, blurHeight: 0};
